import React from 'react'
import { FiBookOpen } from 'react-icons/fi'
import './Iconos.css'

const IconoCohorte = (props) => {
    return <span className={"icono-mp" + (props.background ? " background-cohorte" : "")}><FiBookOpen /></span>
}

export default IconoCohorte